<template>
  <div class="messenger-eye-catcher">
    <messenger-text-with-emoji
      :text="text"
      emoji-size="14px"
      class="messenger-eye-catcher__text"
    />
    <widget-icon
      name="close"
      class="messenger-eye-catcher__close"
      @click="$emit('close')"
    />
  </div>
</template>

<script setup lang="ts">
import MessengerTextWithEmoji from '@widgets/messenger/components/MessengerTextWithEmoji.vue'
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'

defineProps<{
  text: string
}>()

defineEmits<{
  (e: 'close'): void
}>()
</script>

<style scoped lang="scss">
@import '@/styles/custom-variables.scss';

.messenger-eye-catcher {
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: $border-radius-md;
  border: 1px solid $gray2;
  background: $white;
  box-shadow: 0 4px 24px 0 rgba($gray10, 0.13);
  max-width: 300px;
  width: max-content;
  word-break: break-word;
  padding: 10px 16px;
  color: $emphasize;
  font-weight: $medium-font;

  &__close {
    color: $distinct;
    cursor: pointer;
  }
}
</style>
